// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { Subscription } from 'rxjs';

@Component({
  selector: 'coa-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  clientId: string;
  categoryId: string;
  dateRange: DateRangeFilter;
  private subscription = new Subscription();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.getParams();
    this.getQueryParams();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getParams(): void {
    const subscription = this.activatedRoute
      .params
      .subscribe((params) => this.clientId = params.clientId);
    this.subscription.add(subscription);
  }

  private getQueryParams(): void {
    const subscription = this.activatedRoute
      .queryParams
      .subscribe((queryParams) => {
        this.dateRange = queryParams.dateRange;
        this.categoryId = queryParams.categoryId || '';
      });
    this.subscription.add(subscription);
  }
}
